import React, { Component } from 'react';
import './ContractorsInvoicesTable.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import { toUpperFirstLetter } from 'services/utils/text-util';
import Date from 'components/shared/text/Date';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import { todayValidation } from 'services/utils/date-util';
import DocumentLink from 'components/shared/document/DocumentLink';
import Button from 'components/shared/button/Button';
import { InvoiceStatusKeys } from 'domain/invoice';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { connect } from 'react-redux';
import {
  changePageRequest,
  deleteContractorInvoiceRequest,
  loadContractorsInvoicesRequest,
  markAsPaidRequest,
  updateContractorInvoiceRequest,
} from 'components/admin/contractors-invoices/store/actions';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import {
  getInvoices,
  getPaginationInfo,
  searchTextSelector,
} from 'components/admin/contractors-invoices/store/selectors';
import { getCurrentUser } from 'selectors/authentication';
import { TYPES, usersUtil } from 'services/utils/users-util';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import Number from 'components/shared/text/Number';

class ContractorsInvoicesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceIdToDelete: null,
      showDeleteConfirmation: false,
    };
    this.userIsContractor = usersUtil.hasType(
      props.currentUser,
      TYPES.CONTRACTOR
    );
  }

  componentDidMount() {
    this.props.dispatch(loadContractorsInvoicesRequest());
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleDelete = (invoiceId) => {
    this.setState({
      invoiceIdToDelete: invoiceId,
      showDeleteConfirmation: true,
    });
  };

  handleDeleteConfirmation = (response) => {
    const invoiceIdToDelete = this.state.invoiceIdToDelete;
    this.setState({
      invoiceIdToDelete: null,
      showDeleteConfirmation: false,
    });
    if (response) {
      this.props.dispatch(deleteContractorInvoiceRequest(invoiceIdToDelete));
    }
  };

  renderDueDate = (invoice) => {
    const showMarkAsPaid =
      usersUtil.isAdmin(this.props.currentUser) ||
      usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR);
    if (showMarkAsPaid && invoice.status !== InvoiceStatusKeys.PAID) {
      return (
        <DatetimePicker
          isValidDate={todayValidation}
          placeholder="Invoice due date"
          value={invoice.due_date}
          onChange={(value) => this.handleDueDateChange(invoice.id, value)}
        />
      );
    } else {
      return <Date value={invoice.due_date} format="LL" />;
    }
  };

  handleDueDateChange = (invoiceId, dueDate) => {
    this.props.dispatch(updateContractorInvoiceRequest(invoiceId, dueDate));
  };

  handleMarkAsPaid = (invoiceId) => {
    this.props.dispatch(markAsPaidRequest(invoiceId));
  };

  handlePageChange = (page) => {
    this.props.dispatch(changePageRequest(page, this.props.searchText));
  };

  mapInvoices = (invoices) => {
    const showDelete = this.userIsContractor;
    const showMarkAsPaid =
      usersUtil.isAdmin(this.props.currentUser) ||
      usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR);
    return invoices.map((invoice) => {
      let buttonComponent = [];
      if (showDelete && invoice.status !== InvoiceStatusKeys.PAID) {
        buttonComponent.push(
          <Button
            key={1}
            className="button-blue-grey delete"
            label="Delete"
            onClick={() => this.handleDelete(invoice.id)}
          />
        );
      }
      if (showMarkAsPaid && invoice.status !== InvoiceStatusKeys.PAID) {
        buttonComponent.push(
          <Button
            key={2}
            className="button-blue-grey mark-as-paid"
            label="Mark as Paid"
            onClick={() => this.handleMarkAsPaid(invoice.id)}
          />
        );
      }

      return [
        <span className="small-bold">{invoice.work_order_number}</span>,
        this.userIsContractor
          ? invoice.work_order_job !== null
            ? invoice.work_order_job
            : 'N/A'
          : null,
        <span className="small-bold">{invoice.client_name}</span>,
        invoice.contractor_name,
        toUpperFirstLetter(invoice.status),
        this.renderDueDate(invoice),
        <Number value={invoice.cost} format="$0,0" />,
        <DocumentLink showIcon={false} url={invoice.document.document.url} />,
        buttonComponent,
      ].filter((invoice) => invoice); // filter null
    });
  };

  render() {
    const headers = [
      'WO #',
      this.userIsContractor ? 'JOB #' : null,
      'CLIENT NAME',
      'CONTRACTOR NAME',
      'STATUS',
      'DUE DATE',
      'AMOUNT',
      'DOC LINK',
      '', // button
    ].filter((invoice) => invoice !== null); // filter null
    return (
      <div className="contractors-invoices-table">
        <SimpleTable
          className={this.userIsContractor ? 'for-contractor' : ''}
          headers={headers}
          rows={this.mapInvoices(this.props.invoices)}
          emptyMessage="No Invoices for Contractor"
        />

        {this.props.paginationInfo !== null && (
          <div className="pagination-container">
            <SimplePagination
              currentPage={this.props.paginationInfo.currentPage}
              pageSize={this.props.paginationInfo.pageSize}
              total={this.props.paginationInfo.total}
              onPageChange={(page) => this.handlePageChange(page)}
            />
          </div>
        )}
        <ConfirmationModal
          show={this.state.showDeleteConfirmation}
          message="Are you sure?"
          onHide={this.handleDeleteConfirmation}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    invoices: getInvoices(state),
    paginationInfo: getPaginationInfo(state),
    searchText: searchTextSelector(state),
  };
})(ContractorsInvoicesTable);



// WEBPACK FOOTER //
// ./src/components/admin/contractors-invoices/ContractorsInvoicesTable.js